import ButtonProps from "../../Types/ButtonPropsType";

const StyledButton = ({
  text,
  className = "blueButton",
  onClick,
}: ButtonProps) => {
  return (
    <button className={className} onClick={onClick}>
      {text}
    </button>
  );
};

export default StyledButton;
